export default __webpack_public_path__ + "static/media/Profile.f799f7fd.svg";